import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListTab from "./../../factories/generic-list-tab";
import TabPage from "./../../factories/tab-page";


/*
 * ViewModel for a list displaying the assigned mandators for ShiftbookTab
 * */
class ShiftbookTabMandator extends GenericListTab {

    PageSize = ko.observable(0);


    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }

    SearchType(): string {
        return "Uadm-Mandator";
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }

    ControllerUrl = "ShiftbookTabMandator";
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
}
export default ShiftbookTabMandator;